import moment from "moment";
import { DEFAULT_RELATIVE_FROM } from "views/Constants";
import {
  classifyFromRange,
  isTypeRelativeClassified,
  normalizeClassifiedRange,
  RELATIVE_CLASSIFIED_ALL_TIME_RANGE
} from "./RelativeTimeRangeClassifiedHelper";
const getDefaultAbsoluteFromRange = (oldTimeRange) => {
  if (isTypeRelativeClassified(oldTimeRange)) {
    return normalizeClassifiedRange(oldTimeRange.from);
  }
  return DEFAULT_RELATIVE_FROM;
};
const getDefaultAbsoluteToRange = (oldTimeRange) => {
  if (isTypeRelativeClassified(oldTimeRange)) {
    return normalizeClassifiedRange(oldTimeRange.to);
  }
  return 0;
};
const migrationStrategies = {
  absolute: ({
    oldTimeRange,
    formatTime
  }) => ({
    type: "absolute",
    from: formatTime(moment().subtract(getDefaultAbsoluteFromRange(oldTimeRange), "seconds"), "complete"),
    to: formatTime(moment().subtract(getDefaultAbsoluteToRange(oldTimeRange), "seconds"), "complete")
  }),
  relative: () => ({
    type: "relative",
    from: classifyFromRange(DEFAULT_RELATIVE_FROM),
    to: RELATIVE_CLASSIFIED_ALL_TIME_RANGE
  }),
  keyword: ({ userTimezone }) => ({
    type: "keyword",
    keyword: "Last five minutes",
    timezone: userTimezone
  }),
  disabled: () => void 0
};
const migrateTimeRangeToNewType = ({
  oldTimeRange,
  type,
  formatTime,
  userTimezone
}) => {
  const oldType = oldTimeRange && "type" in oldTimeRange ? oldTimeRange.type : "disabled";
  if (type === oldType) {
    return oldTimeRange;
  }
  if (!migrationStrategies[type]) {
    throw new Error(`Invalid time range type: ${type}`);
  }
  return migrationStrategies[type]({ oldTimeRange, formatTime, userTimezone });
};
export default migrateTimeRangeToNewType;
